import { AutoHeightIframe, useIntl } from 'platform-components/common';
import React from 'react';

import './custom-lesson-view__landing.scss';

interface Props {
    src: string | null;
}

export const CustomLessonViewLanding = React.memo(({ src }: Props) => {
    const intl = useIntl();
    const defaultHeight = Number(intl.formatMessage({ id: 'customLessonView.landing.defaultHeight' }));

    const origins = ['https://yandex.ru'];

    if (!isSSR) {
        origins.push(window.location.origin);
    }

    if (!src) {
        return null;
    }

    return (
        <div className="custom-lesson-view__landing-wrapper">
            <AutoHeightIframe
                className="custom-lesson-view__landing"
                defaultHeight={defaultHeight}
                origins={origins}
                src={src}
            />
        </div>
    );
});
